import React from "react";
import PropTypes from "prop-types";

import strings from "../../resources/strings";

class DesktopMessage extends React.Component {
    render() {
        let sendUrlLinkFn = this.props.sendUrlLinkFn;

        return (
            <div className="app-container">
                <div className="w3-container w3-center">
                    <div id="emailSmsLabel" className="w3-left-align w3-margin-top">
                        {strings.getString("desktopMessage")}<br/><br/>
                        {strings.getString("desktopMessageLine1")}<br/><br/>
                        {strings.getString("desktopMessageLine2")}<br/><br/>
                    </div>
    
                    <label id="emailSmsMessage" className="w3-small w3-text-red"></label>
                    <input type="text" id="emailSmsInputField" name="emailSmsInputField"
                            className="w3-input w3-border w3-round-large w3-section"
                            placeholder="Phone Number or Email"/>
                    <button id="emailSmsButton" className="w3-button w3-indigo w3-round-xxlarge w3-large w3-center"
                            onClick={evt => sendUrlLinkFn(evt)}
                    >Submit</button>
    
                    <div id="emailSmsLabel2" className="w3-left-align w3-margin-top">
                        {strings.getString("cameraOrMobileDeviceRequired")}
                    </div>
                </div>
            </div>
        );
    }
}

DesktopMessage.contextTypes = {
    sendUrlLinkFn: PropTypes.func
};

export default DesktopMessage;
